module.exports = __webpack_public_path__ + "static/media/jttw360.37228139.png";